import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["btn", "panel"];

  connect() {
    // Activate tab from URL hash if present
    const hash = window.location.hash?.replace("#", "");
    if (hash) {
      const idx = this.btnTargets.findIndex(
        (btn) => btn.dataset.tabPanel === hash,
      );
      if (idx >= 0) this.select(idx);
    }
  }

  switch(event) {
    const idx = this.btnTargets.indexOf(event.currentTarget);
    if (idx >= 0) this.select(idx);
  }

  select(index) {
    this.btnTargets.forEach((btn, i) => {
      const active = i === index;
      btn.classList.toggle("border-primary-600", active);
      btn.classList.toggle("text-primary-600", active);
      btn.classList.toggle("dark:border-primary-400", active);
      btn.classList.toggle("dark:text-primary-400", active);
      btn.classList.toggle("border-transparent", !active);
      btn.classList.toggle("text-gray-500", !active);
      btn.setAttribute("aria-selected", active);
    });

    this.panelTargets.forEach((panel, i) => {
      panel.classList.toggle("hidden", i !== index);
    });
  }
}
